export { CrumbDetailContextProvider, useCrumbDetailContext } from './use-crumb-detail-context';
